if (!customElements.get('zinko-category-groups')) {
  class ZinkoCategoryGroups extends HTMLElement {
    static expanded = new Map();

    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-group]').forEach((group) => {
        const key = `${this.dataset.mode}:${group.dataset.group}`;
        if (ZinkoCategoryGroups.expanded.has(key)) this.setExpanded(group, ZinkoCategoryGroups.expanded.get(key));
      });
      this.updateSelections();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.zinko-category-toggle');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const group = button.closest('[data-group]');
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        ZinkoCategoryGroups.expanded.set(`${this.dataset.mode}:${group.dataset.group}`, expanded);
        this.setExpanded(group, expanded);
      }, true);
      this.addEventListener('input', (event) => {
        const input = event.target;
        if (input.matches('[data-category-select-all]')) {
          input.closest('[data-group]').querySelectorAll('input[name="filter.p.product_type"]:not(:disabled)').forEach((category) => {
            category.checked = input.checked;
            this.syncValue(category);
          });
          this.updateSelections();
          return;
        }
        if (!input.matches('input[name="filter.p.product_type"]')) return;
        this.syncValue(input);
        this.updateSelections();
      }, true);
    }

    syncValue(input) {
        this.querySelectorAll('input[name="filter.p.product_type"]').forEach((other) => {
          if (other.value === input.value) other.checked = input.checked;
        });
    }

    setExpanded(group, expanded) {
      group.querySelector('button').setAttribute('aria-expanded', String(expanded));
      group.querySelector('ul').hidden = !expanded;
    }

    updateSelections() {
      this.querySelectorAll('[data-group]').forEach((group) => {
        const categories = Array.from(group.querySelectorAll('input[name="filter.p.product_type"]:not(:disabled)'));
        const count = categories.filter((input) => input.checked).length;
        const all = group.querySelector('[data-category-select-all]');
        all.checked = categories.length > 0 && count === categories.length;
        all.indeterminate = count > 0 && count < categories.length;
        all.disabled = categories.length === 0;
        const badge = group.querySelector('.zinko-category-selection');
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    }
  }
  customElements.define('zinko-category-groups', ZinkoCategoryGroups);
}
